// constants
import { showSuccessAlert } from "../../constants/alerts";
import { FaqActionTypes } from "./constants";

const INIT_STATE = {
  faqs: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface faqData {
  id: number;
  question_en: string;
  question_ar: string;
  answer_en: string;
  answer_ar: string;
}

interface faqActionType {
  type:
    | FaqActionTypes.API_RESPONSE_SUCCESS
    | FaqActionTypes.API_RESPONSE_ERROR
    | FaqActionTypes.CREATE_FAQ
    | FaqActionTypes.UPDATE_FAQ
    | FaqActionTypes.GET_FAQ
    | FaqActionTypes.DELETE_FAQ;
  payload: {
    actionType?: string;
    data?: faqData | {};
    error?: string;
    faqs?: [];
  };
}

interface State {
  faqs?: faqData[] | [];
  loading?: boolean;
  value?: boolean;
}

const FaqStates = (state: State = INIT_STATE, action: faqActionType): any => {
  switch (action.type) {
    case FaqActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case FaqActionTypes.CREATE_FAQ: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case FaqActionTypes.GET_FAQ: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            faqs: action.payload.data,
          };
        }
        case FaqActionTypes.UPDATE_FAQ: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case FaqActionTypes.DELETE_FAQ: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case FaqActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case FaqActionTypes.CREATE_FAQ: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case FaqActionTypes.UPDATE_FAQ: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case FaqActionTypes.GET_FAQ: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case FaqActionTypes.DELETE_FAQ: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case FaqActionTypes.CREATE_FAQ:
      return { ...state, loading: true };
    case FaqActionTypes.UPDATE_FAQ:
      return { ...state, loading: true };
    case FaqActionTypes.GET_FAQ:
      return { ...state, loading: true, initialLoading: true };
    case FaqActionTypes.DELETE_FAQ:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default FaqStates;
